export const ADDRESS_CHANGE = "ADDRESS_CHANGE";
export const RESET_ADDRESS = "RESET_ADDRESS";
export const MAP_DELIVERY_ADDRESS = "MAP_DELIVERY_ADDRESS";
